import axios, {AxiosResponse} from 'axios';
import { AccountsVM, SubStateVM } from '../Models/ViewModels';
const api_url = process.env.REACT_APP_STEM_API_BASE_URL+'/api'

const headers = { 
    'Accept': 'application/json',
    'Content-Type': 'application/json'
  } 



export const GetSubStateDetails=()=>{
    return axios.get(api_url+'/SubStateMaster/GetSubstateDetails');
}

export const EditSubState = (editAcc:SubStateVM,loginId:any) =>
   {
      const payload = { "SubStateID" :  editAcc.SubStateId,"SubStateName":editAcc.SubStateName,
      "ProcessName":editAcc.ProcessName,"CaseType":editAcc.CaseType,"Payer":editAcc.Payer,"Action":editAcc.Action,
      "VCFromState":editAcc.VCFromState,"VCToState":editAcc.VCToState,"ModifiedBy":loginId
   }
   
     return axios.post(api_url+'/SubStateMaster/EditSubState',payload,{headers})
     
   }

export const AddSubState = (AddAcc:SubStateVM,loginId:any) =>
   {
      const payload = { "SubStateName":AddAcc.SubStateName,
      "ProcessName":AddAcc.ProcessName,"CaseType":AddAcc.CaseType,"Payer":AddAcc.Payer,"Action":AddAcc.Action,
      "VCFromState":AddAcc.VCFromState,"VCToState":AddAcc.VCToState,"CreatedBy":loginId
   }
   
     return axios.post(api_url+'/SubStateMaster/AddSubState',payload,{headers})
     
   }

export const DeleteSubState=(SubStateID:number)=>{
  
    return axios.post(api_url+'/SubStateMaster/DeleteSubState?substateid='+ SubStateID)
}